import { useQueryClient } from 'react-query';
import { useMemo } from 'react';
import QUERY_KEYS from 'constants/queryKeys';

const useMemoizedQueryOptions = ({
  options,
  organizationId,
  propertyId,
  portalUserId,
}) => {
  const queryClient = useQueryClient();

  return useMemo(() => {
    return {
      ...options,
      onSuccess: (response) => {
        queryClient.invalidateQueries(
          QUERY_KEYS.getAffordaPortalFormByPortalUserId({
            organizationId,
            propertyId,
            portalUserId,
          }),
        );

        if (options?.onSuccess) options?.onSuccess(response);
      },
      enabled: Boolean(propertyId && organizationId && portalUserId),
    };
  }, [options, organizationId, propertyId, queryClient, portalUserId]);
};

export default useMemoizedQueryOptions;
